import { post, request } from "./api";

export type LessonState = "proposed" | "accepted" | "rejected" | "retired";

/** A skill change a lesson suggests. With `canApply`, it carries the exact words to replace. */
export interface SkillChange {
  skill: string;
  section?: string;
  change: string;
  before?: string;
  after?: string;
  status: "proposed" | "applying" | "applied" | "declined";
  canApply: boolean;
  appliedAs?: "library" | "goal";
  appliedTo?: string;
}

/** One lesson as `GET /api/lessons` lists it (workers/src/goals/lessons.ts). */
export interface Lesson {
  id: string;
  code: string;
  claim: string;
  state: LessonState;
  /** The lesson's strength, or "disputed" once the owner disputes it. */
  strength: string;
  whyStrength: string | null;
  evidence: { fact: string; source: string }[];
  applies: string | null;
  call: "agree" | "dispute" | null;
  learnedIn: { goalId: string; sentence: string | null; runId: string | null } | null;
  usedBy: { goalId: string; sentence: string }[];
  skillChange: SkillChange | null;
  createdAt: string;
  decidedAt: string | null;
}

const at = (id: string) => `/lessons/${encodeURIComponent(id)}`;

export const lessonsApi = {
  list: () => request<{ lessons: Lesson[] }>("/lessons"),
  decide: (id: string, decision: "accept" | "reject") => post<{ ok: boolean }>(`${at(id)}/decide`, { decision }),
  call: (id: string, call: "agree" | "dispute" | "retire") => post<{ ok: boolean }>(`${at(id)}/call`, { call }),
  applyChange: (id: string, scope: "library" | "goal") =>
    post<{ appliedAs: "library" | "goal"; appliedTo: string }>(`${at(id)}/skill-change`, { decision: "apply", scope }),
  declineChange: (id: string) => post<{ ok: boolean }>(`${at(id)}/skill-change`, { decision: "decline" }),
};
